export const transparencia_item = [
    {
        "transparencia_item_nombre" : "48 Rubros",
        "transparencia_item_url" : "Rubros"
    },
    {
        "transparencia_item_nombre" : "Rubros Anteriores",
        "transparencia_item_url" : "RubrosHistoricos"
    }
]